import React from 'react';
import PropTypes from 'prop-types';
import findInObject from '@wikom/find-in-object';
import { isGuest, hasBetrieb, betriebsauswahlAktiv } from '../helpers/menuHelpers';
var LoginDetails = function (_a) {
    var user = _a.user;
    return (isGuest(user)
        ? null
        : (React.createElement("div", { className: "header-login-details" },
            hasBetrieb(user)
                && (React.createElement("div", null,
                    React.createElement("strong", { className: "header-company" },
                        findInObject('betrieb.betriebsnr', user),
                        " ",
                        findInObject('betrieb.btsAdresse.betriebsname', user)),
                    React.createElement("br", null),
                    findInObject('betrieb.btsAdresse.titel', user),
                    " ",
                    findInObject('betrieb.btsAdresse.vorname', user),
                    " ",
                    findInObject('betrieb.btsAdresse.nachname', user),
                    React.createElement("br", null),
                    findInObject('betrieb.btsAdresse.strasse', user),
                    ", ",
                    findInObject('betrieb.btsAdresse.plz', user),
                    " ",
                    findInObject('betrieb.btsAdresse.ort', user),
                    React.createElement("br", null))),
            !hasBetrieb(user)
                && (React.createElement("div", null,
                    React.createElement("br", null),
                    React.createElement("br", null),
                    React.createElement("br", null),
                    React.createElement("br", null))),
            betriebsauswahlAktiv(user)
                && (React.createElement("span", null,
                    React.createElement("a", { href: "/user/betriebsauswahl" }, "Betrieb wechseln"),
                    React.createElement("br", null))),
            React.createElement("a", { href: "/user/benutzerdaten" },
                "Angemeldet: ",
                findInObject('vorname', user),
                " ",
                findInObject('nachname', user)),
            "\u00A0",
            React.createElement("a", { href: "/user/logout" },
                React.createElement("i", { className: "fa fa-fw fa-sign-out" }),
                "Abmelden"))));
};
LoginDetails.propTypes = {
    user: PropTypes.object.isRequired,
};
export default LoginDetails;
